// extracted by mini-css-extract-plugin
export default {"previewed":"VariationVersionsList_previewed__aF6lE","row":"VariationVersionsList_row__McVvk","active":"VariationVersionsList_active__og0uP"};